document.addEventListener('DOMContentLoaded', function () {
    // document.addEventListener('click', function (e) {
    //     const btn = e.target.closest('.custom-subscription-atc-btn');
    //     if (!btn) return;
    //     e.preventDefault();
    //     if (btn.classList.contains('loading')) return;
    //     const originalText = btn.innerHTML;
    //     btn.classList.add('loading');
    //     btn.disabled = true;
    //     btn.innerHTML = `
    //         <span class="btn-loader"></span>
    //         Adding...
    //     `;
    //     let itemsList = [];
    //     const variantData = JSON.parse(
    //         document.querySelector('variant-selects [data-selected-variant]')?.innerHTML || '{}'
    //     );
    //     const parentVariantId = variantData.id;
    //     if (!parentVariantId) return;
    //     const sellingPlanId = variantData?.selling_plan_allocations?.[0]?.selling_plan_id || null;
    //     const selectedPlanText = document.querySelector('.custom-subscription .plan-card.active')?.getAttribute('data-plan')?.toLowerCase() || '';
    //     if (sellingPlanId) {
    //         itemsList.push({
    //             id: parseInt(parentVariantId),
    //             quantity: 1,
    //             selling_plan: parseInt(sellingPlanId)
    //         });
    //     }else{
    //        itemsList.push({
    //             id: parseInt(parentVariantId),
    //             quantity: 1
    //         }); 
    //     }
    //     let giftContainer = null;
    //     if (selectedPlanText.includes('90')) {
    //         giftContainer = document.querySelector('.ninty-day-free-gifts');
    //     } else if (selectedPlanText.includes('30')) {
    //         giftContainer = document.querySelector('.thirty-day-free-gifts');
    //     }
    //     if (giftContainer) {
    //         const giftSpans = giftContainer.querySelectorAll('span[data-variant-id]');
    //         giftSpans.forEach(span => {
    //             const variantId = span.getAttribute('data-variant-id');
    //             if (variantId) {
    //                 itemsList.push({
    //                     id: parseInt(variantId),
    //                     quantity: 1,
    //                     parent_id: parseInt(parentVariantId)
    //                 });
    //             }
    //         });
    //     } else {
    //         console.warn('Gift container not found');
    //     }
    //     const thisCart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    //     if (!thisCart) {
    //         console.error('Cart drawer not found');
    //         return;
    //     }
    //     const sections = thisCart.getSectionsToRender().map(section => section.id);
    //     const data = {
    //         items: itemsList,
    //         sections: sections,
    //         sections_url: window.location.pathname
    //     };
    //     fetch('/cart/add.js?sections=cart-drawer,cart-icon-bubble', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(data)
    //     })
    //     .then(res => res.json())
    //     .then(data => {
    //         if (thisCart.classList.contains('is-empty')) {
    //             thisCart.classList.remove('is-empty');
    //         }
    //         thisCart.setActiveElement(document.activeElement);
    //         thisCart.renderContents(data);
    //     })
    //     .catch(err => {
    //         console.error("Error", err);
    //     }).finally(() => {
    //         resetButton();
    //     });
    //     function resetButton() {
    //         btn.classList.remove('loading');
    //         btn.disabled = false;
    //         btn.innerHTML = originalText;
    //     }
    // });

    
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.one-time-wrapper a');
        if (!btn) return;
        e.preventDefault();
        let targetValue = 'One Time Purchase';
        const radios = document.querySelectorAll('input[name^="Plan"]');
        radios.forEach(radio => {
            if (radio.value.toLowerCase() === targetValue.toLowerCase()) {
                const label = document.querySelector(`label[for="${radio.id}"]`);
                if (label) {
                    label.click();
                } else {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        });
        setTimeout(() => {
            const variantData = JSON.parse(
                document.querySelector('variant-selects [data-selected-variant]')?.innerHTML || '{}'
            );
            const parentVariantId = variantData.id;
            const itemsList = [
                {
                    id: parentVariantId,
                    quantity: 1
                }
            ];
            const thisCart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
            if (!thisCart) {
                console.error('Cart drawer not found');
                return;
            }
            const sections = thisCart.getSectionsToRender().map(section => section.id);
            const data = {
                items: itemsList,
                sections: sections,
                sections_url: window.location.pathname
            };
            fetch('/cart/add.js?sections=cart-drawer,cart-icon-bubble', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(res => res.json())
            .then(data => {
                if (thisCart.classList.contains('is-empty')) {
                    thisCart.classList.remove('is-empty');
                }
                thisCart.setActiveElement(document.activeElement);
                thisCart.renderContents(data);
            })
            .catch(err => {
                console.error('Error', err);
            });
        }, 1000);
    });
});